import React from 'react'
import styled from 'styled-components'

import { CloseButton } from 'components/modals/v2/job_rate_edit_modal/components/job_rate_edit_content/styled'
import { colors } from 'helpers/colors'
import SvgCrossMarkOutline from 'components/reusable/svg/svg_cross_mark_outline'
import Text from 'components/reusable/text'
import Indent from 'components/reusable/indent'
import Button from 'components/reusable/button'

export const Wrapper = styled.div`
  width: 480px;
  max-width: 100%;
  padding: 56px 56px 40px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 768px) {
    padding: 24px 16px 16px;
  }
`

function JobRateEditTransition({ rateTransition, onClose }) {
  return (
    <Wrapper>
      <CloseButton onClick={onClose} type="semantic-wrapper">
        <SvgCrossMarkOutline size={24} color={colors.gray[700]} />
      </CloseButton>

      <Text textAlign="center" size={18} weight={500}>
        Switch to hourly rate?
      </Text>

      <Indent top={16} />
      <Text size={14} color={colors.gray[400]} textAlign="center">
        Use hourly for presentations and small projects not requiring usage. For eComm and lookbook select Day Rate.
      </Text>
      <Indent top={40} />
      <Button width="100%" height={40} type="primary" onClick={rateTransition.onChangeRatesTransition(false)}>
        Continue with Day Rate
      </Button>
      <Indent top={16} />
      <Button width="100%" height={40} type="gray-shadow" onClick={rateTransition.switchToHourlyRate}>
        Proceed to Hourly Rate
      </Button>
    </Wrapper>
  )
}

export default JobRateEditTransition
